import { Injectable } from "@angular/core";
import { Observable, Subject, BehaviorSubject } from "rxjs";
import { Listing } from "@app/data/listing";
import { User } from "@app/data/user";

@Injectable({
  providedIn: "root", // Ensures service is singleton and tree-shakable
})
export class GoldenLayoutService {
  selectionSubject = new Subject<any>();
  listingSubject = new BehaviorSubject<Listing | null>(null);
  listingsSubject = new BehaviorSubject<Listing[] | null>(null);
  userSubject = new BehaviorSubject<User | null>(null);

  constructor() {}

  public updateSelection(selection: any): void {
    this.selectionSubject.next(selection);
  }

  public getSelection(): Observable<any> {
    return this.selectionSubject.asObservable();
  }

  public updateListing(listing: Listing): void {
    this.listingSubject.next(listing);
  }

  public updateListings(listings: Listing[]): void {
    this.listingsSubject.next(listings);
  }

  public getListing(): Observable<Listing | null> {
    return this.listingSubject.asObservable();
  }

  public getListings(): Observable<Listing[] | null> {
    return this.listingsSubject.asObservable();
  }

  public updateUser(user: User): void {
    this.userSubject.next(user);
  }

  public getUser(): Observable<User | null> {
    return this.userSubject.asObservable();
  }
}
